module.exports = __webpack_public_path__ + "img/f1fc313c8d06fafc031df1d809629670.png";